export default "__VITE_ASSET__5WdGUCKY__"